var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWavingHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "waving_hand"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.03 4.95L3.49 8.49C0.17 11.81 0.17 17.19 3.49 20.51C6.81 23.83 12.19 23.83 15.51 20.51L21.52 14.5C22.49 13.53 22.49 11.94 21.52 10.96C21.4 10.84 21.27 10.73 21.13 10.64L21.52 10.25C22.49 9.28 22.49 7.69 21.52 6.71C21.36 6.55 21.17 6.41 20.98 6.3C21.38 5.38 21.21 4.28 20.46 3.53C19.59 2.66 18.24 2.57 17.26 3.25C17.16 3.1 17.05 2.96 16.92 2.83C15.95 1.86 14.36 1.86 13.38 2.83L10.87 5.34C10.78 5.2 10.67 5.07 10.55 4.95C9.58 3.98 8 3.98 7.03 4.95ZM8.44 6.37C8.64 6.17 8.95 6.17 9.15 6.37C9.35 6.57 9.35 6.88 9.15 7.08L5.97 10.26C7.14 11.43 7.14 13.33 5.97 14.5L7.38 15.91C8.83 14.46 9.2 12.34 8.5 10.55L14.8 4.25C15 4.05 15.31 4.05 15.51 4.25C15.71 4.45 15.71 4.76 15.51 4.96L10.91 9.56L12.32 10.97L18.33 4.96C18.53 4.76 18.84 4.76 19.04 4.96C19.24 5.16 19.24 5.47 19.04 5.67L13.03 11.68L14.44 13.09L19.39 8.14C19.59 7.94 19.9 7.94 20.1 8.14C20.3 8.34 20.3 8.65 20.1 8.85L14.44 14.51L15.85 15.92L19.39 12.38C19.59 12.18 19.9 12.18 20.1 12.38C20.3 12.58 20.3 12.89 20.1 13.09L14.1 19.1C11.56 21.64 7.45 21.64 4.91 19.1C2.37 16.56 2.37 12.45 4.91 9.91L8.44 6.37ZM23 17C23 20.31 20.31 23 17 23V21.5C19.48 21.5 21.5 19.48 21.5 17H23ZM1 7C1 3.69 3.69 1 7 1V2.5C4.52 2.5 2.5 4.52 2.5 7H1Z",
    fill: "#74C3E1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavingHand);
export default __webpack_public_path__ + "static/media/waving-hand.d8e9040289f17d99f32ecf86e61bf922.svg";
export { ForwardRef as ReactComponent };